import React, { FC, useEffect, useState } from "react";
import { Tabs, Tab, TabPanel, TabList } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import AllUserTable from "../tables/AllUserTable";
import BadregTable from "../tables/BadregTable";
import IncompleteRegTable from "../tables/IncompleteRegTable";
import CompleteRegTable from "../tables/CompleteRegTable";
import SupportMessageTable from "../tables/SupportMessageTable";
import axios from "axios";
import { isAuth } from "../../../auth/ProtectedRoute";

const UserManagementTab: FC = () => {
  const [allTotal, setAllTotal] = useState<number>(0);
  const [completeTotal, setCompleteTotal] = useState<number>(0);
  const [incompleteTotal, setIncompleteTotal] = useState<number>(0);
  const [badTotal, setBadTotal] = useState<number>(0);

  const fetchTotals = async () => {
    const types = [
      { type: "all", setter: setAllTotal },
      { type: "complete_registrations", setter: setCompleteTotal },
      { type: "incomplete_registrations", setter: setIncompleteTotal },
      { type: "bad_registrations", setter: setBadTotal },
    ];

    types.forEach(async ({ type, setter }) => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOST_API}manage-user/list?type=${type}&per_page=1`,
          {
            headers: { Authorization: `Bearer ${isAuth()}` },
          }
        );
        setter(response.data?.data?.pagination?.total || 0);
      } catch (err) {
        console.error(`Error fetching ${type} total:`, err);
      }
    });
  };

  useEffect(() => {
    fetchTotals();
  }, []);

  const getAllTotal = (val: number) => setAllTotal(val);
  const getCompleteTotal = (val: number) => setCompleteTotal(val);
  const getIncompleteTotal = (val: number) => setIncompleteTotal(val);
  const getBadTotal = (val: number) => setBadTotal(val);

  return (
    <div className="task-dashboard" style={{ padding: "40px" }}>
      <div
        className="project-table"
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Tabs style={{ flex: 1 }}>
          <TabList
            style={{
              borderBottom: "none",
              margin: 0,
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <Tab className="project-tab">
              <span className="tab-label">All Users</span>
              <span className="tab-count">{allTotal}</span>
            </Tab>
            <div style={{ height: "20px", width: "1px", background: "#E8E8E8", margin: "0 25px" }}></div>
            <Tab className="project-tab">
              <span className="tab-label">Complete Registration</span>
              <span className="tab-count">{completeTotal}</span>
            </Tab>
            <div style={{ height: "20px", width: "1px", background: "#E8E8E8", margin: "0 25px" }}></div>
            <Tab className="project-tab">
              <span className="tab-label">Incomplete Registration</span>
              <span className="tab-count">{incompleteTotal}</span>
            </Tab>
            <div style={{ height: "20px", width: "1px", background: "#E8E8E8", margin: "0 25px" }}></div>
            <Tab className="project-tab">
              <span className="tab-label">Bad Registration</span>
              <span className="tab-count">{badTotal}</span>
            </Tab>
          </TabList>

          <TabPanel>
            <AllUserTable getCount={getAllTotal} />
          </TabPanel>
          <TabPanel>
            <CompleteRegTable getCount={getCompleteTotal} />
          </TabPanel>
          <TabPanel>
            <IncompleteRegTable getCount={getIncompleteTotal} />
          </TabPanel>
          <TabPanel>
            <BadregTable getCount={getBadTotal} />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};

export default UserManagementTab;
